import React, { useState, useRef } from 'react';
import DebouncedSearch from '../../../common/form/debounced-search';
import StatePicker from '../../../common/state-picker';
import ChainPicker from './chain-picker';
import CsvFileUpload from './csv-file-upload';
import StatusPicker from "../../../common/form/status-picker";

const statusOptions = [
  { value: "init", label: "INIT" },
  { value: "observe", label: "OBSERVE" },
  { value: "merge", label: "MERGE" },
  { value: "review", label: "REVIEW" },
  { value: "active", label: "ACTIVE" },
  { value: "archive", label: "ARCHIVE" },
  { value: "inactive", label: "INACTIVE" },
];

function LocationsSearch({ query, submit, exportLocations, updateSearch, clearSearch }) {
  function handleSubmit(e) {
    e.preventDefault();
  }

  function handleExportClick(e) {
    e.preventDefault();
    exportLocations();
  }

  return (
    <div className='mx-auto sm:px-6 lg:px-8'>
      <form className='flex items-start gap-3 mt-4' onSubmit={handleSubmit}>
        <DebouncedSearch
          placeholder={"Search by name"}
          query={query.name}
          update={(value) => {
            updateSearch('name', value);
          }}
        />
        <DebouncedSearch
          placeholder={"Search by address"}
          query={query.address}
          update={(value) => {
            updateSearch('address', value);
          }}
        />
        <DebouncedSearch
          placeholder={"Search by city"}
          query={query.city}
          update={(value) => {
            updateSearch('city', value);
          }}
        />
        <StatePicker
          state={query.state_code}
          update={(value) => {
            updateSearch('state_code', value);
          }}
        />
        <ChainPicker
          chain_id={query.chain_id}
          update={(value) => {
            updateSearch('chain_id', value);
          }}
        />
        <StatusPicker
          label="Select Status"
          value={query.status}
          onChange={(value) => {
            updateSearch('status', value);
          }}
          options={statusOptions}
        />
        <button className="h-[40px] shadow-sm bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 focus:border-indigo-500 sm:text-sm"
                onClick={(e) => {
          e.preventDefault();
          clearSearch()
        }}>
          Clear
        </button>

        <button
          onClick={handleExportClick}
          className="h-[40px] shadow-sm ml-auto bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 focus:border-indigo-500 sm:text-sm">
          Export
        </button>
      </form>
    </div>
  )
}
export default LocationsSearch;